import { Device } from '@@partner:types:app'
import React from 'react'

import { Button, SelectPicker, Table } from 'rsuite'
import { SortType } from 'rsuite/esm/Table'

import AppLoader from '@components/common/AppLoader'
import { generatePath, Link } from 'react-router-dom'
import { ROUTE_DEVICES_EDIT_DEVICE, ROUTE_SHOPS_EDIT_SHOP } from '@@partner:config/routes'
import { useFetchShops } from '@@partner:graphql/query/shop/shops.gql'
import { useMutateUpdateShopDeviceInfo } from '@@partner:graphql/mutation/device/updateShopDeviceInfo.gql'
import { GQL_ID } from '@@partner:types:graphql'

type DevicesTableProps = {
  brandSlug: string
  devices: Device[]
  loading?: boolean
  onSortColumn?: ((dataKey: string, sortType?: SortType) => void) | undefined
  tableSort: {
    fieldName: string
    direction: number
    sortType: SortType
  }
}

const Column = Table.Column
const HeaderCell = Table.HeaderCell
const Cell = Table.Cell

export default function DevicesTable ({
  brandSlug,
  devices = [],
  loading = false,
  onSortColumn,
  tableSort
}: DevicesTableProps) {

  const { data, loading: loadingShops } = useFetchShops()

  const [ updateShopDeviceInfo ] = useMutateUpdateShopDeviceInfo()

  const handleShopChange = async (deviceId: GQL_ID, shopId: GQL_ID | null) => {
    if (shopId) {
      try {
        await updateShopDeviceInfo({
          variables: {
            newData: {
              id: deviceId,
              shop_id: shopId
            }
          }
        })
      } 
      catch (e) {
        console.error(e)
      }
    }
  }

  return (
    <Table
      data={devices}
      autoHeight
      wordWrap
      loading={loading}
      onSortColumn={onSortColumn}
      sortColumn={tableSort.fieldName}
      sortType={tableSort.sortType}
      affixHeader
      renderLoading={() =>
        loading ? <AppLoader.Inner content="Загрузка таблицы" /> : null
      }
    >
      <Column sortable flexGrow={1} verticalAlign="middle">
        <HeaderCell>ID</HeaderCell>
        <Cell dataKey="id" />
      </Column>
      <Column sortable flexGrow={3} verticalAlign="middle">
        <HeaderCell>Магазин</HeaderCell>
        <Cell dataKey="shop">
          {(device: Device) => {
            if (loadingShops) {
              return <AppLoader.Inner content="Загрузка магазинов" />
            }
            return (
              <SelectPicker
                value={device.shop_id}
                data={data?.shops ?? []}
                onChange={(value) =>
                  handleShopChange(device.id, value)
                }
                searchable={true}
                placeholder="Магазин"
                valueKey="id"
                labelKey="address"
                cleanable={false}
              />
            )
          }}
        </Cell>
      </Column>
      <Column sortable flexGrow={2} verticalAlign="middle">
        <HeaderCell>Название</HeaderCell>
        <Cell dataKey="device_name" />
      </Column>
      <Column sortable flexGrow={2} verticalAlign="middle">
        <HeaderCell>Тип</HeaderCell>
        <Cell dataKey="device_type" />
      </Column>
      <Column sortable flexGrow={2} verticalAlign="middle">
        <HeaderCell>Модель</HeaderCell>
        <Cell dataKey="device_model" />
      </Column>
      <Column sortable flexGrow={2} verticalAlign="middle">
        <HeaderCell>ОС</HeaderCell>
        <Cell dataKey="device_os" />
      </Column>
      <Column sortable flexGrow={2} verticalAlign="middle">
        <HeaderCell>Версия ОС</HeaderCell>
        <Cell dataKey="device_os_version" />
      </Column>
      <Column sortable flexGrow={2} verticalAlign="middle">
        <HeaderCell>Версия приложения</HeaderCell>
        <Cell dataKey="device_app_version" />
      </Column>
    </Table>
  )

}